import { pushTriggerToPosthog } from './usePosthog';
import { useFeatureSwitch } from './useFeatureSwitch';
import useCustomRouter from './useCustomRouter';
import routes from 'src/constants/routes';
import { Pages } from 'src/types/pages';
import { CarJourneyType } from '../services';

export const useExperiment = () => {
    const { isPosthogEnabled } = useFeatureSwitch();
    const router = useCustomRouter();

    const pushTrigger = (
        trigger: string,
        page: string,
        action?: string | null,
        customer?: string | null,
        position?: string | null,
        payment?: string | null,
        vehicle?: object | null,
        outboundLinkCLick?: string | null,
        feature?: string | null,
        softConversion?: string | null,
        changeJourney?: string | null,
        conversion?: string | null,
        configurationMethod?: string | null,
        stageView?: string | null
    ) => {
        if (isPosthogEnabled) {
            pushTriggerToPosthog({
                trigger,
                page,
                action,
                customer,
                position,
                payment,
                vehicle,
                outboundLinkCLick,
                feature,
                softConversion,
                changeJourney,
                conversion,
                configurationMethod,
                stageView,
            });
        }
    };

    const getPageNameByUrl = (): string => {
        const currentPath = router.asPath;

        switch (true) {
            case router.pathname === `/${CarJourneyType.STOCK}` ||
                router.pathname === `/${CarJourneyType.CONFIGURABLE}`:
                return 'home';
            case currentPath.includes(routes.SELECTOR):
                return 'trim';
            case currentPath.includes(routes.BASKET):
                return 'basket';
            case currentPath.includes(routes.CAR):
                return 'selector';
            case currentPath.includes(routes.DEALER):
                return 'dealer';
            case currentPath.includes(routes.CHECKOUT_DELIVERY):
            case currentPath.includes(routes.CHECKOUT_MY_DETAILS):
            case currentPath.includes(routes.CHECKOUT_ORDER_REVIEW):
            case currentPath.includes(routes.CHECKOUT_PRE_ORDER):
            case currentPath.includes(routes.CHECKOUT_CONFIRMATION):
                return 'checkout';
            case currentPath.includes(routes.SUMMARY):
                return 'summary';
            default:
                return 'N/A';
        }
    };

    const getStageViewByUrl = (): string => {
        const currentPath = router.asPath;

        switch (true) {
            case router.pathname === `/${CarJourneyType.STOCK}` ||
                router.pathname === `/${CarJourneyType.CONFIGURABLE}`:
                return 'homepage';
            case currentPath.includes(routes.SELECTOR):
                return 'trim';
            case currentPath.includes(routes.BASKET):
                return 'basket';
            case currentPath.includes(routes.CAR):
                return 'configurable';
            case currentPath.includes(routes.DEALER):
                return 'dealers';
            case currentPath.includes(routes.CHECKOUT_DELIVERY):
            case currentPath.includes(routes.CHECKOUT_MY_DETAILS):
            case currentPath.includes(routes.CHECKOUT_ORDER_REVIEW):
            case currentPath.includes(routes.CHECKOUT_PRE_ORDER):
            case currentPath.includes(routes.CHECKOUT_CONFIRMATION):
                return 'personal details';
            case currentPath.includes(routes.SUMMARY):
                return 'summary';
            default:
                return 'N/A';
        }
    };

    return {
        pushTrigger,
        getPageNameByUrl,
        getStageViewByUrl,
    };
};
